<div class="modal-container">
  <span class="modal-icon-wrapper">
    <i class="cm-icons cm-icons-clock" aria-hidden="true"></i>
  </span>
  <h4 class="modal-heading" data-automation="inactivityTimeErrorText">
    {{ "inactivity_modal_title" | content }}
  </h4>
  <p class="inactivity-error-text body3" data-automation="inactivityErrorText">
    {{ "inactivity_modal_description" | content }}
  </p>
</div>
<div class="login-cta-wrapper">
  <app-button
    text="inactivity_modal_continue_btn"
    color="primary"
    (clickEvent)="closeInactivityDialog(false)"
    automationAttribute="InactivityContinueButton"
  />
  <app-button
    text="inactivity_modal_logout_btn"
    color="primary"
    (clickEvent)="closeInactivityDialog(true)"
    automationAttribute="InactivityLoginButton"
  />
</div>
